/**
 * @file Garde d'accès aux routes du panel admin par section.
 * @module packages.common.guards.AdminSectionGuard
 *
 * Vérifie que l'utilisateur détient la section requise (session.adminAccess,
 * clés du registre config/adminSections). Le super admin passe toujours.
 * Fail-closed : sans section accordée, redirection vers l'accueil admin.
 *
 * Le backend reste l'autorité (requireAdminSection) — ce guard évite juste
 * d'afficher des pages vides ou des erreurs 403 à l'utilisateur.
 */

import PropTypes from 'prop-types';
import {Navigate} from 'react-router-dom';
import useSessionStore from 'packages/common/stores/sessionStore';
import {usePermissions} from 'packages/common/hooks/session';
import {paths} from 'packages/common/routes/paths';
import {SESSION_STATUS} from 'packages/common/stores/sessionStatus';

export default function AdminSectionGuard({section, superAdminOnly = false, children}) {
  const status = useSessionStore((s) => s.status);
  const {hasAdminSection, isSuperAdmin} = usePermissions();

  // Session pas encore prête : AuthGuard gère la redirection login
  if (status !== SESSION_STATUS.READY) {
    return null;
  }

  const allowed = superAdminOnly ? isSuperAdmin : hasAdminSection(section);

  if (!allowed) {
    return <Navigate to={paths.admin.root} replace />;
  }

  return <>{children}</>;
}

AdminSectionGuard.propTypes = {
  children: PropTypes.node,
  section: PropTypes.string,
  superAdminOnly: PropTypes.bool,
};
